module.exports = "https://static.cdns.space/tarot-temp/img/the-popess.07b88315.webp";